import { fetchEulaContent } from "@/api/functions/cms.api";
import Loader from "@/ui/Loader/Loder";
import { useQuery } from "react-query";

export default function EulaPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["eula"],
    queryFn: fetchEulaContent,
  });

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "90vh",
        }}
      >
        <Loader />;
      </div>
    );
  }

  return (
    <div
      style={{ maxWidth: "1024px", margin: "0 auto", padding: "20px" }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: data?.content,
      }}
    />
  );
}
